import { render } from "./CertificateView.vue?vue&type=template&id=8e161b84&scoped=true"
import script from "./CertificateView.vue?vue&type=script&lang=js"
export * from "./CertificateView.vue?vue&type=script&lang=js"

import "./CertificateView.vue?vue&type=style&index=0&id=8e161b84&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e161b84"]])

export default __exports__